import { FtBtnBox, StepWrap } from "style/inspect";

interface StepProps {
  handleNext: () => void;
  title: string;
  description: string;
  imgPath: string;
}

const InspectStepOne = ({
  handleNext,
  description,
  imgPath,
  title,
}: StepProps) => {
  return (
    <>
      <StepWrap>
        <div className="box">
          <div className="box-item-1">
            {title}
            <br />{" "}
          </div>
        </div>
        <div className="box">
          <div className="box-item-2">
            <span>{description}</span>
            <div className="img-box">
              <img src={imgPath} alt="" />
            </div>
          </div>
        </div>
      </StepWrap>
      <FtBtnBox>
        <button onClick={handleNext}>검사 시작하기</button>
      </FtBtnBox>
    </>
  );
};

export default InspectStepOne;
